import { render, staticRenderFns } from "./attendance_types.vue?vue&type=template&id=2d636e4d&scoped=true"
import script from "./attendance_types.vue?vue&type=script&lang=js"
export * from "./attendance_types.vue?vue&type=script&lang=js"
import style0 from "./attendance_types.vue?vue&type=style&index=0&id=2d636e4d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d636e4d",
  null
  
)

export default component.exports